import React from 'react'
import { numFormat, cpfCnpj } from '@rededompedro/utils';
import { Button, Icon } from 'semantic-ui-react';

export default function RelatoriosExibicao({ empresa, registros, form, clearState }) {

    const [
        totalCredGasolina, 
        totalDebGasolina, 
        totalCredGasAdit, 
        totalDebGasAdit, 
        totalCredEtanol, 
        totalDebEtanol,
        totalCredDiesel,
        totalDebDiesel,
        totalCredDieselS10,
        totalDebDieselS10
    ] = [
        registros.map(x => x[22395]).map(x => x.creditos).reduce((a,b) => a+b,0),
        registros.map(x => x[22395]).map(x => x.debitos).reduce((a,b) => a+b,0),
        registros.map(x => x[22398]).map(x => x.creditos).reduce((a,b) => a+b,0),
        registros.map(x => x[22398]).map(x => x.debitos).reduce((a,b) => a+b,0),
        registros.map(x => x[22396]).map(x => x.creditos).reduce((a,b) => a+b,0),
        registros.map(x => x[22396]).map(x => x.debitos).reduce((a,b) => a+b,0),
        registros.map(x => x[22394]).map(x => x.creditos).reduce((a,b) => a+b,0),
        registros.map(x => x[22394]).map(x => x.debitos).reduce((a,b) => a+b,0),
        registros.map(x => x[7087990]).map(x => x.creditos).reduce((a,b) => a+b,0),
        registros.map(x => x[7087990]).map(x => x.debitos).reduce((a,b) => a+b,0),
    ]

    return (
        <>
            <div className="d-flex w-100 d-print-none mb-3">
                <Button size='mini' className='ml-auto btn-primary' onClick={() => window.print()}><Icon name='print' /> Imprimir</Button>  
                <Button size='mini' className='mr-0 btn-red' onClick={() => clearState()}> 
                    <Icon name='arrow left' /> Voltar
                </Button>  
            </div>
            <table className="demonstrativo w-100 border border-dark page-break">

                <thead>
                    <tr className='border border-dark p-2'><th colSpan='11' className='text-center'>REGULAMENTO ICMS</th></tr>
                    <tr>
                        <td className='p-2' colSpan='11'>
                            <div className="row">
                                <div className="col-2">Empresa:</div>
                                <div className="col">{empresa && empresa.nomeEmpresa}</div>
                            </div>
                            <div className="row">
                                <div className="col-2">CNPJ:</div>
                                <div className="col">{empresa && cpfCnpj(empresa.cnpjPrincipal)}</div>
                            </div>
                            <div className="row">
                                <div className="col-2">Periodo:</div>
                                <div className="col">{form.dataIni} à {form.dataFim}</div>
                            </div>
                        </td>
                    </tr>
                    <tr className='border border-dark p-2'>
                        <td rowSpan='2' className='text-center'>Data</td>
                        <td colSpan='10' className='border border-dark text-center' style={{ letterSpacing: 15 }}>COMBUSTÍVEIS</td>
                    </tr>
                    <tr className='border border-dark p-2'>
                        <td colSpan='2' className='text-center border border-dark'>Gasolina</td>
                        <td colSpan='2' className='text-center border border-dark'>Gasolina Aditivada</td>
                        <td colSpan='2' className='text-center border border-dark'>Etanol</td>
                        <td colSpan='2' className='text-center border border-dark'>Diesel Comum</td>
                        <td colSpan='2' className='text-center border border-dark'>Diesel S-10</td>
                    </tr>
                </thead>

                <tbody>

                    {registros.map((row, idx) => <tr key={idx} className='border border-dark p-2 border-bottom-0 border-top-0'>
                        <td className='text-center border border-dark border-bottom-0 border-top-0'>{row.data}</td>
                        <td className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">NF-e</div></div>
                            <div className="row my-0"><div className="col">Base</div></div>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </td>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row my-0"><div className="col">{row[22395].notas.length ? row[22395].notas.join(' | ') : 'N/A' }</div></div>
                            <div className="row my-0"><div className="col">{row[22395].precos.length ? row[22395].precos.map(x => numFormat(x, 4)).join(' | ') : 'N/A'}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(row[22395].creditos)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(row[22395].debitos)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(Math.abs(row[22395].creditos - row[22395].debitos) > 0 ? Math.abs(row[22395].creditos - row[22395].debitos) : 0)}</div></div>
                        </td>
                        <td className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">NF-e</div></div>
                            <div className="row my-0"><div className="col">Base</div></div>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </td>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row"><div className="col">{row[22398].notas.length ? row[22398].notas.join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{row[22398].precos.length ? row[22398].precos.map(x => numFormat(x, 4)).join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{numFormat(row[22398].creditos)}</div></div>
                            <div className="row"><div className="col">{numFormat(row[22398].debitos)}</div></div>
                            <div className="row"><div className="col">{numFormat(Math.abs(row[22398].creditos - row[22398].debitos) > 0 ? Math.abs(row[22398].creditos - row[22398].debitos) : 0)}</div></div>
                        </td>
                        <td className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">NF-e</div></div>
                            <div className="row my-0"><div className="col">Base</div></div>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </td>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row"><div className="col">{row[22396].notas.length ? row[22396].notas.join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{row[22396].precos.length ? row[22396].precos.map(x => numFormat(x, 4)).join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{numFormat(row[22396].creditos)}</div></div>
                            <div className="row"><div className="col">{numFormat(row[22396].debitos)}</div></div>
                            <div className="row"><div className="col">{numFormat(Math.abs(row[22396].creditos - row[22396].debitos) > 0 ? Math.abs(row[22396].creditos - row[22396].debitos) : 0)}</div></div>
                        </td>
                        <td className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">NF-e</div></div>
                            <div className="row my-0"><div className="col">Base</div></div>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </td>
                        <td className='text-right pr-2 pr-2 border border-dark border-left-0'>
                            <div className="row"><div className="col">{row[22394].notas.length ? row[22394].notas.join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{row[22394].precos.length ? row[22394].precos.map(x => numFormat(x, 4)).join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{numFormat(row[22394].creditos)}</div></div>
                            <div className="row"><div className="col">{numFormat(row[22394].debitos)}</div></div>
                            <div className="row"><div className="col">{numFormat(Math.abs(row[22394].creditos - row[22394].debitos) > 0 ? Math.abs(row[22394].creditos - row[22394].debitos) : 0)}</div></div>
                        </td>
                        <td className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">NF-e</div></div>
                            <div className="row my-0"><div className="col">Base</div></div>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </td>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row"><div className="col">{row[7087990].notas.length ? row[7087990].notas.join(' | ') : ''}</div></div>
                            <div className="row"><div className="col">{row[7087990].precos.length ? row[7087990].precos.map(x => numFormat(x, 4)).join(' | ') : 'N/A'}</div></div>
                            <div className="row"><div className="col">{numFormat(row[7087990].creditos)}</div></div>
                            <div className="row"><div className="col">{numFormat(row[7087990].debitos)}</div></div>
                            <div className="row"><div className="col">{numFormat(Math.abs(row[7087990].creditos - row[7087990].debitos) !== '' ? Math.abs(row[7087990].creditos - row[7087990].debitos) : 0)}</div></div>
                        </td>
                    </tr>)}

                    <tr className='border border-dark p-2'>
                        <th className='text-center border border-dark border-bottom-0 border-top-0'>TOTAIS</th>
                        <th className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </th>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row my-0"><div className="col">{numFormat(totalCredGasolina)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(totalDebGasolina)}</div></div>
                            <div className="row my-0"><div className="col" style={{ color: totalCredGasolina - totalDebGasolina < 0 ? 'red' : ''}}>{numFormat(totalCredGasolina - totalDebGasolina)}</div></div>
                        </td>
                        <th className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </th>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row my-0"><div className="col">{numFormat(totalCredGasAdit)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(totalDebGasAdit)}</div></div>
                            <div className="row my-0"><div className="col" style={{ color: totalCredGasAdit - totalDebGasAdit < 0 ? 'red' : ''}}>{numFormat(totalCredGasAdit - totalDebGasAdit)}</div></div>
                        </td>
                        <th className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </th>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row my-0"><div className="col">{numFormat(totalCredEtanol)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(totalDebEtanol)}</div></div>
                            <div className="row my-0"><div className="col" style={{ color: totalCredEtanol - totalDebEtanol < 0 ? 'red' : ''}}>{numFormat(totalCredEtanol - totalDebEtanol)}</div></div>
                        </td>
                        <th className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </th>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row my-0"><div className="col">{numFormat(totalCredDiesel)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(totalDebDiesel)}</div></div>
                            <div className="row my-0"><div className="col" style={{ color: totalCredDiesel - totalDebDiesel < 0 ? 'red' : ''}}>{numFormat(totalCredDiesel - totalDebDiesel)}</div></div>
                        </td>
                        <th className='text-left pl-3 border border-dark border-right-0'>
                            <div className="row my-0"><div className="col">Crédito</div></div>
                            <div className="row my-0"><div className="col">Débito</div></div>
                            <div className="row my-0"><div className="col">Saldo</div></div>
                        </th>
                        <td className='text-right pr-2 border border-dark border-left-0'>
                            <div className="row my-0"><div className="col">{numFormat(totalCredDieselS10)}</div></div>
                            <div className="row my-0"><div className="col">{numFormat(totalDebDieselS10)}</div></div>
                            <div className="row my-0"><div className="col" style={{ colo0r: totalCredDieselS10 - totalDebDieselS10 < 0 ? 'red' : ''}}>{numFormat(totalCredDieselS10 - totalDebDieselS10)}</div></div>
                        </td>
                    </tr>

                </tbody>

            </table>

            {/* <div className="row">
                <div className="col-12 col-md d-flex align-items-end">
                    <p className='mb-0'>
                        <strong>Período:</strong> {form.dataIni} - {form.dataFim}
                    </p>
                </div>
                <div className='col-12 col-md-2 d-print-none'>
                    <Button animated='fade' size='tiny' color='orange' floated='right' onClick={clearState}>
                        <Button.Content visible><Icon name='arrow left' /></Button.Content>
                        <Button.Content hidden>Voltar</Button.Content>
                    </Button>
                    <Button icon size='tiny' color='blue' floated='right' onClick={() => window.print()}>
                        <Icon name='print' /> Imprimir
                    </Button>
                </div>
            </div>
            <Table id='table-relatorios-ricms' size='small' compact fixed inverted sortable selectable {...config} /> */}
        </>
    )
}
